module.exports = "<div *ngIf=\"!unityChartReady\" style=\"display: block; width: 100%; margin: auto;\">\n    <app-spinner-div [message]=\"'Loading 3D charts...'\"></app-spinner-div>\n    <div class=\"row\">\n        <mat-progress-bar mode=\"determinate\" [value]=\"(progress * 100)\"></mat-progress-bar>\n    </div>\n</div>\n<div #unityEl id=\"gameContainer\" style=\"display: block; width: 100%; min-height: 0; margin: auto;\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/unity-chart/unity-chart.component.html
// module id = ../../../../../angular/app/components/unity-chart/unity-chart.component.html
// module chunks = main